import type { Question, Section } from "./data"

export type Mode = "practice-short" | "practice-full" | "section" | "study"

export interface AnswerResult {
  given: number
  givenText: string
  correct: boolean
}

interface State {
  allQuestions: Question[] // base set for this quiz run
  queue: number[] // indices (into allQuestions) of UN-answered questions
  selections: Record<number, number> // qIdx -> selected option idx (tentative, pre-confirm)
  results: Record<number, AnswerResult> // qIdx -> confirmed answer
  wasSkipped: Record<number, boolean> // qIdx -> true, for "returned from skip" indicator
  confirmed: boolean // is the current question's answer confirmed?
  shuffledChoices: Record<number, string[]> // qIdx -> option texts in display order (stable per run)
  currentMode: Mode | null
  currentSection: Section | null
}

export const state: State = {
  allQuestions: [],
  queue: [],
  selections: {},
  results: {},
  wasSkipped: {},
  confirmed: false,
  shuffledChoices: {},
  currentMode: null,
  currentSection: null,
}
